import { render, staticRenderFns } from "./SeguroSortePremiada.vue?vue&type=template&id=6774402f"
import script from "./SeguroSortePremiada.vue?vue&type=script&lang=js"
export * from "./SeguroSortePremiada.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports